<template>
  <div class="fit-warper">
    <div class="title pf-medium">适用人群</div>
    <h3>{{ applyPeople }}</h3>
    <p>{{ applicability }}</p>
  </div>
</template>

<script>
export default {
  props: {
    applyPeople: {
      type: String,
      default: ''
    },
    applicability: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/css/mixin';
.fit-warper {
  line-height: normal;
  position: relative;
  height: 100%;

  .title {
    height: rem(108px);
    @include ellicpsis;
    font-size: rem(32px);
    padding-left: rem(32px);
    color: #121212;
    letter-spacing: 0;
    line-height: rem(108px);
    border-bottom: #ededed 1px solid;
  }

  h3 {
    color: #333333ff;
    font-weight: 500;
    font-size: rem(30px);
    margin: rem(32px) rem(32px) 0;
  }
  p {
    margin: rem(12px) rem(32px) 0;
    color: #666666ff;
    font-size: rem(28px);
  }
}
</style>
